import { useEffect, useMemo, useState } from "react";

/** A low-frequency clock for user-visible minute-granularity expiry copy. */
export function useMinuteNow(): Date {
  const [timestamp, setTimestamp] = useState(Date.now);

  useEffect(() => {
    const interval = setInterval(() => setTimestamp(Date.now()), 60_000);
    return () => clearInterval(interval);
  }, []);

  return useMemo(() => new Date(timestamp), [timestamp]);
}
